import { render } from "./index-banner.vue?vue&type=template&id=7b122de0"
import script from "./index-banner.vue?vue&type=script&lang=js"
export * from "./index-banner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__